import { useLocation, Link } from "react-router-dom";
import { useState } from "react";
import { Menu } from "lucide-react";
import LeadFormModal from "@/pages/lead_inventory/LeadFormModal";
import PageSubHeader from "./pageSubHeader.jsx";
import MobileMenu from "./MobileMenu.jsx";

import logo from "../assets/MMlogo.png";
import { toast } from "react-toastify";

const PageHeader = () => {
  const location = useLocation();
  const role = localStorage.getItem("role");
  const user = Number(localStorage.getItem("userId"));
  const email = localStorage.getItem("email");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const isHybrid = localStorage.getItem("is_hybrid") === "true";

  let isAdmin = false;
  let isHunter = false;
  let isHeadHunter = false;
  let isFarmer = false;
  let isHeadFarmer = false;

  if (role) {
    if (role === "Admin") {
      isAdmin = true;
    } else if (role === "Farmer") {
      if (user === 18) {
        isHeadFarmer = true;
      }
      isFarmer = true;
    } else {
      if (user === 157) {
        isHeadHunter = true;
      }
      isHunter = true;
    }
  }

  if (isHybrid) {
    isHunter = true;
    isFarmer = true;
  }

  const getTitle = () => {
    if (location.pathname === "/home") return "Dashboard";
    if (location.pathname === "/leadDistribution") return "Lead Distribution";
    if (
      location.pathname === "/lead_inventory/yours" ||
      location.pathname === "/lead_inventory/all" ||
      location.pathname === "/lead_inventory/shark_tank"
    )
      return "Lead Inventory";
    if (
      location.pathname === "/account_distribution/incoming" ||
      location.pathname === "/account_distribution/assigned"
    )
      return "Accounts Distribution";
    if (
      location.pathname === "/account_inventory/yours" ||
      location.pathname === "/account_inventory/all"
    )
      return "Accounts Inventory";
    if (
      location.pathname === "/opportunity_inventory/yours" ||
      location.pathname === "/opportunity_inventory/all"
    )
      return "Opportunity Inventory";
    if (location.pathname === "/admin") return "Admin";
    if (location.pathname === "/lead_journey")
      return "Lead / Lead Journey Pipeline";
    if (location.pathname === "/account_details")
      return "Accounts / Account Details";
    if (location.pathname === "/opportunity_journey")
      return "Opportunity / Opportunity Journey";
    if (location.pathname === "/settings")
      return "Settings";

    return "";
    
  };

  // Page type flags
  const isLead =
    [
      "/lead_inventory/yours",
      "/lead_inventory/all",
      "/lead_inventory/shark_tank",
    ].includes(location.pathname) || location.pathname === "/lead_journey";

  const isAccDistribution = [
    "/account_distribution/incoming",
    "/account_distribution/assigned",
  ].includes(location.pathname);

  const isAccInventory =
    ["/account_inventory/yours", "/account_inventory/all"].includes(
      location.pathname
    ) || location.pathname === "/account_details";

  const isOpportunity = [
    "/opportunity_inventory/yours",
    "/opportunity_inventory/all",
  ].includes(location.pathname);

  const isSettings = [
    "/settings",
  ].includes(location.pathname);

  // Detail / journey pages
  const isLeadJourneyPage = location.pathname === "/lead_journey";
  const isOppJourneyPage = location.pathname === "/opportunity_journey";
  const isAccountDetailsPage = location.pathname === "/account_details";

  // Where the back button should go
  const backTo = isLeadJourneyPage
    ? "/lead_inventory/yours"
    : isOppJourneyPage
    ? "/opportunity_inventory/yours"
    : isAccountDetailsPage
    ? "/account_inventory/yours"
    : null;

  const showBackButton = Boolean(backTo);

  return (
    <div className="sticky top-0 bg-white shadow z-40">
      <nav className="flex items-center justify-between px-4 md:px-6 lg:px-8 pt-2">
        {/* Mobile: Hamburger + Logo */}
        <div className="flex items-center lg:hidden">
          <button
            onClick={() => setIsMobileMenuOpen(true)}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors mr-2"
            aria-label="Open menu"
          >
            <Menu className="w-6 h-6 text-gray-600" />
          </button>
          <Link to="/home" className="flex items-center space-x-1">
            <img
              src={logo}
              alt="Logo"
              className="h-8 object-contain"
            />
            <b className="text-gray-500 text-sm">CSP</b>
            <span className="text-gray-500 text-sm">4.0</span>
          </Link>
        </div>

        {/* Desktop: Logo + Email */}
        <div className="hidden lg:flex items-center">
          <div className="text-lg font-bold">
            <Link to="/home" className="flex items-center space-x-2">
              <div className="w-36 h-16 rounded-xl flex items-center justify-center">
                <img
                  src={logo}
                  alt="Logo"
                  className="Logo h-12 object-contain"
                />
              </div>
              <b className="text-gray-500">CSP</b>
              <span className="text-gray-500">4.0</span>
            </Link>
          </div>
          {email && <div className="text-gray-400 text-sm ml-2">{email}</div>}
        </div>

        {/* Desktop: Navigation Links */}
        <div className="hidden lg:flex space-x-6 font-bold">
          <Link
            to="/home"
            className={`hover:text-yellow-300 ${
              location.pathname === "/home"
                ? "pb-2 border-b-4 border-[#F7E21E] text-[#1E293B]"
                : "text-gray-400 font-bold"
            }`}
          >
            Home
          </Link>

          {(isHunter || isAdmin) && (
            <>
              <Link
                to="/lead_inventory/yours"
                className={`hover:text-yellow-300 ${
                  isLead
                    ? "pb-2 border-b-4 border-[#F7E21E] text-[#1E293B]"
                    : "text-gray-400 font-bold"
                }`}
              >
                Leads
              </Link>
            </>
          )}

          {(isFarmer || isAdmin) && (
            <>
              {(isHeadFarmer || isAdmin) && (
                <Link
                  to="/account_distribution/incoming"
                  className={`hover:text-yellow-300 ${
                    isAccDistribution
                      ? "pb-2 border-b-4 border-[#F7E21E] text-[#1E293B]"
                      : "text-gray-400"
                  }`}
                >
                  Accounts Distribution
                </Link>
              )}
              <Link
                to="/account_inventory/yours"
                className={`hover:text-yellow-300 ${
                  isAccInventory
                    ? "pb-2 border-b-4 border-[#F7E21E] text-[#1E293B]"
                    : "text-gray-400"
                }`}
              >
                Accounts
              </Link>
              <Link
                to="/opportunity_inventory/yours"
                className={`hover:text-yellow-300 ${
                  isOpportunity
                    ? "pb-2 border-b-4 border-[#F7E21E] text-[#1E293B]"
                    : "text-gray-400"
                }`}
              >
                Opportunities
              </Link>
            </>
          )}
          
          {(isAdmin || isHeadFarmer || isHeadHunter) && (
            <Link
              to="/settings"
              className={`hover:text-yellow-300 ${
                isSettings
                  ? "pb-2 border-b-4 border-[#F7E21E] text-[#1E293B]"
                  : "text-gray-400 font-bold"
              }`}
            >
              Settings
            </Link>
          )}
        </div>

        {/* Mobile: Email (right side) */}
        {email && (
          <div className="lg:hidden text-gray-400 text-xs truncate max-w-[120px]">
            {email}
          </div>
        )}
      </nav>

      {/* Mobile Menu */}
      <MobileMenu
        isOpen={isMobileMenuOpen}
        onClose={() => setIsMobileMenuOpen(false)}
        role={role}
        isAdmin={isAdmin}
        isHunter={isHunter}
        isFarmer={isFarmer}
        isHeadFarmer={isHeadFarmer}
        isHeadHunter={isHeadHunter}
      />

      <div>
        <PageSubHeader
          title={getTitle()}
          role={role}
          isHunter={isHunter}
          isFarmer={isFarmer}
          showBackButton={showBackButton}
          backTo={backTo}  // ⬅️ new
        />
      </div>
    </div>
  );
};

export default PageHeader;